import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import SectionTitle from "../../components/Common/SectionTitle";
import ConsultationServiceSingle from "../../components/Consultation/ConsultationServiceSingle";

import bgImg from "../../assets/img/bg/home-8.jpg";
import { ConsultationService } from "../../services/ConsultationService";
import Error from "../../components/Error/Error";
import Loader from "../../components/Common/Loader";

const bgStyle = {
  backgroundImage: `url(${bgImg})`,
  "background-size": "cover",
  "background-repeat": "no-repeat",
  "background-position": "center center",
};

const ConsultationServices = () => {
  const [items, setItems] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const getConsultationServices = () => {
    ConsultationService.getServices()
      .then((response) => {
        setLoading(false);
        if (response.data.success && response.data.data && response.data.data.page) {
          setItems(response.data.data.page);
        } else {
          setItems([]);
        }
      })
      .catch((ex) => {
        console.log(ex);
        setLoading(false);
        setItems([]);
      });
  };

  useEffect(() => {
    getConsultationServices();
  }, []);

  // Group items into rows of 2
  const rows = [];
  for (let i = 0; i < items.length; i += 2) {
    rows.push(items.slice(i, i + 2));
  }

  return (
    <div
      className="rs-popular-courses style1 pt-94 pb-70 md-pt-64 md-pb-40"
      style={bgStyle}
    >
      <div className="container">
        <div className="row y-middle mb-50 md-mb-30">
          <div className="col-md-6 sm-mb-30">
            <SectionTitle
              sectionClass="sec-title"
              subtitleClass="sub-title primary"
              subtitle="Consultation Services"
              titleClass="title mb-0 fs-5"
              title="Get expert consultation from our world-class professionals. We provide specialized guidance in software development, security, and digital marketing to help your business grow."
            />
          </div>
          <div className="col-md-6">
            <div className="btn-part text-right sm-text-left">
              <Link to="/consultation" className="readon">
                Book a Consultation
              </Link>
            </div>
          </div>
        </div>

        {isLoading ? (
          <Loader color="#ffc107" size="150px" />
        ) : rows.length > 0 ? (
          rows.map((row, rowIdx) => (
            <div key={rowIdx} style={{ display: "flex", gap: "32px", marginBottom: "32px", flexWrap: "wrap" }}>
              {row.map((item) => (
                <ConsultationServiceSingle
                  key={item.id}
                  serviceClass="consultation-horizontal-card"
                  serviceImg={item.thumbnail}
                  serviceTitle={item.title}
                  serviceDescription={item.description}
                />
              ))}
            </div>
          ))
        ) : (
          <></>
          // <Error title="Oops!" message="Consultation Services Not Available" />
        )}
      </div>
    </div>
  );
};

export default ConsultationServices; 